import { Epic } from 'redux-observable';
import { filter, map, catchError, withLatestFrom, switchMap } from 'rxjs/operators';
import { isActionOf } from 'typesafe-actions';
import { AjaxResponse } from 'rxjs/ajax';
import { of } from 'rxjs';
import { RootAction } from 'store/actions';
import { RootState } from 'store/reducer';
import * as actions from './actions';
import { RootDependencies } from 'store/dependencies';
import { AppInstanceConfigBlobDefinition } from './types';

export const getAppInstanceConfigBlobDefinition: Epic<RootAction, RootAction, RootState, RootDependencies> = (
  action$,
  state$,
  { apiClient },
) =>
  action$.pipe(
    filter(isActionOf(actions.getAppInstanceConfigBlobDefinition.request)),
    withLatestFrom(state$),
    switchMap(([action, state]) => {
      const { payload: uuid } = action;

      return apiClient(state)
        .getAppInstanceConfigBlobDefinition(uuid)
        .pipe(
          map(({ response }: AjaxResponse) =>
            actions.getAppInstanceConfigBlobDefinition.success({
              uuid,
              data: response as AppInstanceConfigBlobDefinition,
            }),
          ),
          catchError((error: Error) => of(actions.getAppInstanceConfigBlobDefinition.failure({ uuid, error }))),
        );
    }),
  );
